import {FC} from 'react';

import MainLogo from '../../MainLogo';
import s from '../styles.module.scss';

const LightHeaderContent: FC = () => (
  <div className={s['header-root']}>
    <MainLogo variant="small" />
  </div>
);

export default LightHeaderContent;
